import { Directive, forwardRef, Input } from '@angular/core';
import { NG_VALIDATORS, FormControl } from '@angular/forms';

function maxValidationFactory() {
	return (c: FormControl, maxValidation) => {
		if (Number(c.value) > Number(maxValidation)) {
			return {
				maxValidation: true,
			}
		}

		return;
	}
}

@Directive({
  selector: '[maxValidation][ngModel]',
  providers: [
    {
    	provide: NG_VALIDATORS,
    	useExisting: forwardRef(() => MaxValidationDirective), multi: true
    }
  ]
})
export class MaxValidationDirective {
  validator: Function;
  @Input() maxValidation

  constructor() {
    this.validator = maxValidationFactory();
  }

  validate(c: FormControl) {
    return this.validator(c, this.maxValidation);
  }
}
